import React from 'react';
import { Egg } from 'lucide-react';
import { getPokemonImageUrl } from '../../utils/imageUtils';

const EggHatchesSection = ({ eggHatches }) => {
  if (!eggHatches || eggHatches.length === 0) return null;

  // Group by egg type
  const groupedByType = eggHatches.reduce((acc, egg) => {
    const type = egg.egg_type || 'unknown';
    if (!acc[type]) acc[type] = [];
    acc[type].push(egg);
    return acc;
  }, {});

  return (
    <div className="bg-white rounded-2xl shadow-lg p-6 md:p-8">
      <div className="flex items-center gap-3 mb-6">
        <Egg className="w-6 h-6 text-pink-500" />
        <h2 className="text-2xl font-bold text-gray-800">Egg Hatches</h2>
      </div>
      
      {Object.entries(groupedByType).map(([eggType, eggs]) => (
        <div key={eggType} className="mb-6 last:mb-0">
          <h3 className="text-lg font-semibold text-gray-700 mb-3">
            {eggType} Eggs
          </h3>
          <div className="grid grid-cols-3 sm:grid-cols-4 md:grid-cols-6 gap-4">
            {eggs.map((egg, index) => {
              const imageUrl = egg.pokemon_id 
                ? getPokemonImageUrl(egg.pokemon_id)
                : '/images/pokemon/0000.webp';
              
              return (
                <div
                  key={index}
                  className="bg-gray-50 rounded-xl p-3 text-center hover:shadow-md transition-shadow"
                >
                  <img
                    src={imageUrl}
                    alt={egg.pokemon_name || 'Pokemon'}
                    className="w-16 h-16 mx-auto object-contain mb-2"
                    onError={(e) => {
                      e.target.src = '/images/pokemon/0000.webp';
                    }}
                  />
                  <p className="font-medium text-gray-800 text-xs">
                    {egg.pokemon_name || 'Unknown'}
                  </p>
                  {egg.is_shiny_available && (
                    <span className="inline-block mt-1 text-[10px] text-yellow-600 font-bold">
                      ✨
                    </span>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      ))}
    </div>
  );
};

export default EggHatchesSection;
